if (!customElements.get('products-toolbar')) {
  class ProductsToolbar extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.init.bind(this));
    }

    init() {
      // Elements
      this.filterBtn = this.querySelector('.js-toggle-filters');
      this.toolbarCount = document.getElementById('toolbar-filter-count');
      this.sortBtn = this.querySelector('.js-toggle-sort');
      this.filtersDrawer = document.querySelector('.main-products-grid__filters');
      this.sortDrawer = document.getElementById('sort-drawer');
      this.overlay = document.querySelector('.toolbar-overlay');
      
      this.pendingSearchParams = new URLSearchParams(window.location.search);

      this.layoutSwitcher = this.querySelector('.products-toolbar__layout');
      if (this.layoutSwitcher) {
        this.layoutSwitcher.addEventListener('change', (e) => {
          const grid = document.querySelector('.main-products-grid');
          if(grid) grid.dataset.layout = e.target.value;
          theme.storageUtil.set('products-layout', e.target.value);
        });
      }

      const viewRadios = this.querySelectorAll('input[name="card-view"]');
      if (viewRadios.length) {
        // A. Handle Change
        viewRadios.forEach(radio => {
          radio.addEventListener('change', (e) => {
            this.setCardView(e.target.value);
          });
        });

        // B. Load saved preference
        const savedView = theme.storageUtil.get('card-view');
        if (savedView) {
          const toggle = this.querySelector(`input[name="card-view"][value="${savedView}"]`);
          if (toggle) {
            toggle.click();
          } else {
            this.setCardView(savedView); // Apply even if radio not found
          }
        }
      }
      

      // 1. Setup Filters
      if (this.filtersDrawer) {
        this.buildFilterTabs(this.filtersDrawer);
        this.injectFooter(this.filtersDrawer); 
        
        if (this.filterBtn) {
          this.filterBtn.addEventListener('click', (e) => {
            e.preventDefault();
            this.openDrawer(this.filtersDrawer);
            // Reset pending on open
            this.pendingSearchParams = new URLSearchParams(window.location.search); 
            this.updateDrawerUI(); 
          });
        }
        
        // Listen for changes inside the drawer
        this.filtersDrawer.addEventListener('change', (e) => {
          if(e.target.matches('input[type="checkbox"]')) {
             this.updateDrawerUI();
          }
        });
      }

      // 2. Setup Sort
      if (this.sortDrawer && this.sortBtn) {
        this.sortBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.openDrawer(this.sortDrawer);
        });
      }

      // 3. Global Events
      this.bindCloseEvents();

      // 4. Sort Logic
      const sortRadios = document.querySelectorAll('input[name="sort_by_drawer"]');
      sortRadios.forEach(radio => {
        radio.addEventListener('change', (e) => {
          this.handleSortChange(e.target.value);
        });
      });
    }

    setCardView(viewName) {
      const grid = document.querySelector('.main-products-grid');
      if (grid) {
        // Sets data-card-view="option1" or "option2"
        grid.dataset.cardView = viewName; 
        theme.storageUtil.set('card-view', viewName);
      }
    }

    buildFilterTabs(drawer) {
      if (drawer.querySelector('.drawer-header')) return; 

      const header = document.createElement('div');
      header.className = 'drawer-header';
      header.innerHTML = `
        <div class="drawer-header-top">
          <h3 class="drawer-title">Filter</h3>
          <button type="button" class="drawer-close-btn js-close-drawers">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg>
          </button>
        </div>
      `;

      const nav = document.createElement('div');
      nav.className = 'filter-tabs-nav';
      
      const details = drawer.querySelectorAll('details, .js-filter');
      let filteredIndex = 0;
      
      details.forEach((group) => {
        const summary = group.querySelector('summary, .summary-label');
        if (!summary) return;
        const labelText = summary ? summary.innerText.trim().split('(')[0] : `Filter ${filteredIndex + 1}`;
        
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = `filter-tab-btn ${filteredIndex === 0 ? 'is-active' : ''}`;
        btn.innerHTML = `${labelText} <span class="filter-tab-count is-hidden" data-index="${filteredIndex}">0</span>`;
        
        btn.addEventListener('click', () => {
          nav.querySelectorAll('.filter-tab-btn').forEach(b => b.classList.remove('is-active'));
          btn.classList.add('is-active');
          details.forEach(d => { d.removeAttribute('open'); d.style.display = 'none'; });
          group.setAttribute('open', '');
          group.style.display = 'block';
        });

        nav.appendChild(btn);

        if (filteredIndex === 0) {
          group.setAttribute('open', '');
          group.style.display = 'block';
        } else {
          group.removeAttribute('open');
          group.style.display = 'none';
        }

        filteredIndex++;
      });

      header.appendChild(nav);
      drawer.insertBefore(header, drawer.firstChild);
      header.querySelector('.js-close-drawers').addEventListener('click', this.closeAll.bind(this));
    }

    injectFooter(drawer) {
      if (drawer.querySelector('.drawer-footer')) return;

      const footer = document.createElement('div');
      footer.className = 'drawer-footer';
      footer.innerHTML = `
        <button type="button" class="drawer-footer-btn-reset">Reset</button>
        <button type="button" class="drawer-footer-btn-apply">
          <span class="btn-spinner"></span>
          <span class="btn-text">See Results</span>
        </button>
      `;

      drawer.appendChild(footer);

      footer.querySelector('.drawer-footer-btn-reset').addEventListener('click', () => {
        drawer.querySelectorAll('input[type="checkbox"]').forEach(input => input.checked = false);
        this.pendingSearchParams = new URLSearchParams(); 
        this.updateDrawerUI();
      });

      const applyBtn = footer.querySelector('.drawer-footer-btn-apply');
      applyBtn.addEventListener('click', () => {
        this.closeAll();
        const baseUrl = window.location.pathname;
        const params = this.pendingSearchParams.toString();
        window.location.href = params ? `${baseUrl}?${params}` : baseUrl;
      });
    }

    updateDrawerUI() {
      // 1. Calculate Params
      const form = this.filtersDrawer.querySelector('form');
      const newParams = new URLSearchParams();
      
      form.querySelectorAll('input[type="checkbox"]:checked').forEach(input => {
        newParams.append(input.name, input.value);
      });

      const currentSort = new URLSearchParams(window.location.search).get('sort_by');
      if(currentSort) newParams.set('sort_by', currentSort);

      this.pendingSearchParams = newParams;

      // 2. Update Tabs
      const details = this.filtersDrawer.querySelectorAll('details, .js-filter');
      let filteredIndex = 0;
      
      details.forEach((group) => {
        const summary = group.querySelector('summary, .summary-label');
        if (!summary) return;
        
        const checked = group.querySelectorAll('input[type="checkbox"]:checked').length;
        const tabCount = document.querySelector(`.filter-tab-count[data-index="${filteredIndex}"]`);
        if(tabCount) {
          tabCount.textContent = `(${checked})`;
          tabCount.classList.toggle('is-hidden', checked === 0);
        }
        
        filteredIndex++;
      });

      // 3. Update Reset Text
      const totalChecked = this.filtersDrawer.querySelectorAll('input[type="checkbox"]:checked').length;
      const resetBtn = this.filtersDrawer.querySelector('.drawer-footer-btn-reset');
      if(resetBtn) resetBtn.textContent = totalChecked > 0 ? `Reset (${totalChecked})` : 'Reset';

      // 4. FETCH COUNT
      this.fetchResultCount(newParams);
    }

    /**
     * UPDATED: Removes section_id to fix 404 and improves counting logic
     */
    fetchResultCount(params) {
      const applyBtn = this.filtersDrawer.querySelector('.drawer-footer-btn-apply');
      const btnText = applyBtn.querySelector('.btn-text');
      
      // applyBtn.classList.add('is-loading');
      btnText.textContent = 'Loading...';

      // FIX: Removed "&section_id=..." to prevent 404 errors. 
      // We fetch the full page now, which is safer.
      const url = `${window.location.pathname}?${params.toString()}`; 

      fetch(url)
        .then(response => {
          if (!response.ok) throw new Error('Network response was not ok');
          return response.text();
        })
        .then(text => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(text, 'text/html');
          
          let count = 0;
          let found = false;

          // STRATEGY 1: Read from the Mobile Button (Most accurate for your theme)
          const mobileBtn = doc.querySelector('.js-close-drawer-mob');
          if (mobileBtn) {
             const num = mobileBtn.innerText.replace(/[^0-9]/g, '');
             if (num !== "") {
               count = parseInt(num);
               found = true;
             }
          }

          // STRATEGY 2: Count Product Cards directly
          // This is a backup if Strategy 1 fails
          if (!found) {
             // We look for common grid item classes
             const cards = doc.querySelectorAll('.card-wrapper, .product-card, .grid__item .card, .product-item, .card--product');
             if(cards.length > 0) {
                count = cards.length;
                found = true;
             }
          }
          
          // STRATEGY 3: Look for generic count text
          if (!found) {
             const countEl = doc.querySelector('#ProductCount, .product-count, .product-count-text');
             if(countEl) {
               const num = countEl.innerText.replace(/[^0-9]/g, '');
               if(num) count = parseInt(num);
             }
          }

          btnText.textContent = `See ${count} Results`;
        })
        .catch((e) => {
          console.error('Fetch error:', e);
          btnText.textContent = 'See Results'; // Fallback text on error
        })
        .finally(() => {
          applyBtn.classList.remove('is-loading');
        });
    }

    bindCloseEvents() {
      if (this.overlay) this.overlay.addEventListener('click', this.closeAll.bind(this));
      document.querySelectorAll('.js-close-drawers').forEach(btn => btn.addEventListener('click', this.closeAll.bind(this)));
    }
    openDrawer(drawer) {
      this.closeAll();
      drawer.classList.add('is-active');
      if (this.overlay) this.overlay.classList.add('is-active');
      document.body.style.overflow = 'hidden';
    }
    closeAll() {
      if (this.filtersDrawer) this.filtersDrawer.classList.remove('is-active');
      if (this.sortDrawer) this.sortDrawer.classList.remove('is-active');
      if (this.overlay) this.overlay.classList.remove('is-active');
      document.body.style.overflow = '';
    }
    handleSortChange(value) {
      const urlObj = new URL(window.location.href);
      urlObj.searchParams.set('sort_by', value);
      window.location.href = urlObj.toString();
    }
  }

  customElements.define('products-toolbar', ProductsToolbar);
}